import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import store from "./redux/store";
import App from "./App";
import UserService from "./services/UserService";
import axios from "axios";
import './globals';
import '@boldreports/javascript-reporting-controls/Scripts/bold.report-designer.min';
import '@boldreports/javascript-reporting-controls/Scripts/bold.report-viewer.min';

//Data-Visualization
import '@boldreports/javascript-reporting-controls/Scripts/data-visualization/ej.bulletgraph.min';
import '@boldreports/javascript-reporting-controls/Scripts/data-visualization/ej.chart.min';
//Reports react base
import '@boldreports/react-reporting-components/Scripts/bold.reports.react.min';

axios.interceptors.request.use(
  (config: any) => {
    const token = localStorage.getItem("token");
    const { sideBarReducer } = store.getState();
    const { companyDetails }: any = sideBarReducer;
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
      config.headers["company-id"] = companyDetails?.companyId ||  "";
    }
    //  config.headers['Content-Type'] = 'application/json';
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    // //console.log(response, 'response in response');
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },
  (error) => {
    //console.log(error.response, "Error in response");

    if (error?.response?.status === 401) {
      UserService.doLogout();
    }

    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
  }
);

const renderApp = () =>
  ReactDOM.render(
    <React.StrictMode>
      <BrowserRouter basename="app/revlog">
        <Provider store={store}>
          <App />
        </Provider>
      </BrowserRouter>
    </React.StrictMode>,
    document.getElementById("root")
  );
UserService.initKeycloak(renderApp);
